"use client";

import { LOCALE_COOKIE, type Locale } from "@/lib/i18n";

function setCookie(name: string, value: string, days = 365) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(
    value,
  )}; expires=${expires}; path=/`;
}

export function LanguageToggle({ locale }: { locale: Locale }) {
  function switchTo(next: Locale) {
    if (next === locale) return;
    setCookie(LOCALE_COOKIE, next);
    window.location.reload();
  }

  const enButton = (
    <button
      type="button"
      onClick={() => switchTo("en")}
      className={`rounded-full px-2 py-1 font-semibold transition ${
        locale === "en" ? "bg-slate-900 text-white" : "text-slate-600"
      }`}
    >
      EN
    </button>
  );

  const arButton = (
    <button
      type="button"
      onClick={() => switchTo("ar")}
      className={`rounded-full px-2 py-1 font-semibold transition ${
        locale === "ar" ? "bg-slate-900 text-white" : "text-slate-600"
      }`}
    >
      ع
    </button>
  );

  return (
    <div className="inline-flex items-center rounded-full border border-slate-200 bg-white px-1 py-1 text-xs shadow-sm">
      {locale === "ar" ? (
        <>
          {arButton}
          {enButton}
        </>
      ) : (
        <>
          {enButton}
          {arButton}
        </>
      )}
    </div>
  );
}

